import { failed } from "../../components/common/Toastify"

export const onError = (error) => {
    console.log(error.message)
    failed(error?.response?.data?.message || error?.response?.data?.error || error.message)
}